/**
* this is the account pages which show the member profile
*
* Created by Min on 10/08/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import config from '../../config'
import { isEmpty } from '../../utility/utilities'


// action import
import { ActionCreator } from '../../actions/'

// component import
import SimpleLoader from '../../components/SimpleLoader/'
import AppButton from '../../components/AppButton'

// icon imports
import DocIcon from '../../assets/svg/documents-blank.svg'
import PdfIcon from '../../assets/svg/pdf.svg'
import InProgressIcon from '../../assets/svg/signing_in_progress.svg'
import CompleteIcon from '../../assets/svg/signing_complete.svg'

// style import
import './style.scss'


class Documents extends Component {
    componentDidMount() {
        const { getDocSignStatus, getDocumentsData, getProfileData } = this.props
        getProfileData()
        getDocSignStatus()
        getDocumentsData()
    }

    renderSignDoc() {
        const signURL = config.endpoints.docSignLinkFetchURL

        return (
            <div>
                <div className="documents__doc-sign">
                    <div className="doc-sign__title">
                        IMPORTANT
                    </div>
                    <div className="doc-sign__desc">
                        In order to finalise your SMSF setup you must sign your documents.  As the account holder you can click the link below to sign.
                        Additional members and trustees on the fund will receive an email with a link where they can complete the signing process. <br /><br />
                        Some documents will need to be downloaded and wet signed to meet legal requirements, please follow the insrtuction in the signing process.
                    </div>
                </div>
                <div className="documents__download-action">
                    <span>These documents must be reviewed and digitally signed.</span>
                    <a target="_blanlk" href={ signURL } className="doc-sign__link">
                        <AppButton
                            buttonText="Sign all documents"
                            size="small"
                            color="blue"
                        />
                    </a>
                </div>
            </div>
        )
    }

    renderPendingDoc() {

        return (
            <div>
                <div className="documents__doc-status">
                    <p className="documents__doc-status__in-progress" >
                        <img
                            src={InProgressIcon}
                            className="documents__doc-status__signing-icon"
                            alt="Signing In progress icon"
                        />
                        SIGNING IN PROGRESS
                    </p>
                </div>
                <div className="documents__doc-sign">
                    <div className="doc-sign__title">
                        IMPORTANT
                    </div>
                    <div className="doc-sign__desc">
                        Signing has not been completed by all members / trustees.
                         Additional members and trustees on the fund will receive an email with a link where they can complete the signing process. <br /><br />
                         You can check the progress of the document signing by downloading the documents below.
                    </div>
                </div>
                <div className="documents__download-action">
                </div>
            </div>
        )
    }

    renderCompletedDoc() {

        return (
            <div>
                <div className="documents__doc-status">
                    <p className="documents__doc-status__completed" >
                        <img
                            src={CompleteIcon}
                            className="documents__doc-status__signing-icon"
                            alt="Signing Completed icon"
                        />
                        SIGNING COMPLETED
                    </p>
                </div>
                <div className="documents__download-action">
                </div>
            </div>
        )
    }

    renderDocument (id,name) {
        const { docSignStatus } = this.props
        const primaryStatus = docSignStatus.primary_recipient_status
        const docLink = `${process.env.REACT_APP_WEBSITE_URL}/api/document/${id}/download`

        return (
            <div className="documents__documents-item" key={id}>
                <img
                    src={PdfIcon}
                    className="documents-item__pdf-icon"
                    alt="Pdf icon"
                />
                <span className="documents-item__name" >{name}</span>
                { primaryStatus === "completed" &&
                    <a className="documents-item__download-btn" target="_blank" href={docLink}>
                        <AppButton
                            buttonText="Download"
                            size="small"
                            color="blue"
                        />
                    </a>
                }
            </div>
        )
    }

    renderDocuments(documents) {
        return (
            <div>
                { documents.map((ele, index)=>this.renderDocument(ele['id'],ele['name'])) }
            </div>
        )
    }

    renderEmptyData(){

        return(
            <div className="documents-empty-content">
                <div className="documents-empty-content__header">Please wait while we prepare your documents.</div>
                <div className="documents-empty-content__body-text">
                    It can take up to 10 minutes to prepare your documents. <br/>
                    Once they are ready for your review you can download and sign them. <br/>
                    Thank you for your patience.
                </div>
                <img
                    src={DocIcon}
                    className="documents-empty-content__icon"
                    alt="Empty doc icon"
                />
            </div>
        )

    }

    renderContent() {
        const { documents, documentsloading, docSignStatus } = this.props
        const primaryStatus = docSignStatus.primary_recipient_status,
              otherStatus = docSignStatus.status_text

        return (

                !documentsloading && documents &&
                    <div>
                        {/* render block based on status - Primary user not signed */}
                        { primaryStatus !=="completed" && this.renderSignDoc()}
                        {/* render block based on status - Primary user signed but not trustees */}
                        { otherStatus !=="completed" &&  primaryStatus === "completed"  && this.renderPendingDoc()}
                        {/* render block based on status - All signed */}
                        { otherStatus ==="completed" &&  primaryStatus === "completed"  && this.renderCompletedDoc()}

                        {documents && this.renderDocuments(documents)}
                    </div>

        )
    }


    render() {
        const { documentsloading, docSignStatus,  documents} = this.props

        return (
            <div className="documents main-wrapper" >

                <div className="main-container">

                    <div className="page-title">DOCUMENTS</div>

                    <div className="documents-container">

                        {/* render loader */}
                        <SimpleLoader
                            num={4}
                            show={documentsloading}
                            title="Please wait while we fetch the documents."
                        />

                        {/* render content */}

                        {/* If docusign ready */}
                        { docSignStatus !== false && !isEmpty(documents) &&  this.renderContent() }

                        {/* If docusign not ready */}
                        { (docSignStatus === false || isEmpty(documents)) && documentsloading === false && this.renderEmptyData() }

                    </div>
                </div>
            </div>
        )
    }
}

// define the prop types
Documents.propTypes = {
    getDocSignStatus: PropTypes.func.isRequired,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        docSignStatus : state.documentsState.docSignStatus,
        documents : state.documentsState.documents,
        isSigned : state.profileState.data['prim_sign_status'],
        documentsloading : state.documentsState.documentsloading,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getDocSignStatus : action.getDocSignStatus,
        getDocumentsData : action.getDocumentsData,
        getProfileData : action.getProfileData
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Documents)



// WEBPACK FOOTER //
// ./src/pages/Documents/index.js